require('./rateStatusRow.i18n.json');
require('./rateStatusRow.tpl.html');
require('./rateStatusRowController.js');
require('./umRateStatusRowDomManager.js');

const RateStatusRowComponent = {
    templateUrl: '/configuration/rateStatus/rateStatusRow/rateStatusRow.tpl.html',
    controller: 'rateStatusRowController',
    bindings: {
        item: '<',
        locations: '<',
        products:'<',
        statuses: '<',
        isEmptyRow: '<?',
        isReadOnly: '<?',
        hasUnsavedChanges: '<?',
        validateAction: '&?',
    }
};

angular.module('ums.configuration')
    .component('uiRateStatusRow', RateStatusRowComponent);

